import {
  Checkbox,
  DatePicker,
  Input,
  InputNumber,
  Select,
  ColorPicker,
} from "antd";
import moment from "moment";
import React, { useMemo } from "react";
import ImageUploader from "../imageUpload";
import i18n from "i18next";
import { formatColor, typeForm } from "../Constant";
import { IconMapping } from "../IconSelector/constants";

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

const formatDateWithTime = (date) => {
  return (
    [
      padTo2Digits(date.getDate()),
      padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join("-") +
    " " +
    [
      padTo2Digits(date.getHours()),
      padTo2Digits(date.getMinutes()),
      padTo2Digits(date.getSeconds()),
    ].join(":")
  );
};
const formatTime = (date) => {
  return [
    padTo2Digits(date.getHours()),
    padTo2Digits(date.getMinutes()),
    padTo2Digits(date.getSeconds()),
  ].join(":");
};
const formatDate = (date) => {
  return (
    [
      padTo2Digits(date.getDate()),
      padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join("-") + ""
  );
};

const formateDateYYYYMMDD = (date) => {
  return (
    [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join("-") + ""
  );
};
const formateDateYYYYMMDDWithTime = (date) => {
  return (
    [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join("-") +
    " " +
    [
      padTo2Digits(date.getHours()),
      padTo2Digits(date.getMinutes()),
      padTo2Digits(date.getSeconds()),
    ].join(":")
  );
};
const rules = ({ t, required }) => {
  return [
    {
      required: required,
      message: t("Required"),
    },
  ];
};

export const preventEnterToSubmit = (e) =>
  e.key === "Enter" ? e.preventDefault() : "";

const renderFormComponent = (item, lstDisabled) => {
  const onDrop = (picture) => {
    item.setFileList(picture);
  };

  switch (item.type) {
    case typeForm.text:
      return (
        <Input disabled={item.disabled} onKeyDown={preventEnterToSubmit} />
      );
    case typeForm.textarea:
      return <Input.TextArea />;
    case typeForm.password:
      return <Input.Password />;
    case typeForm.select:
      return (
        <Select
          //suffixIcon={null}
          showSearch
          disabled={item.disabled || lstDisabled.includes(item.accessor)}
          options={item.options}
          allowClear={item.isAllowClearSelect}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          onChange={item.onChange}
        />
      );
    case typeForm.number:
      return (
        <InputNumber
          style={{ width: "100%" }}
          disabled={item.disabled}
          onKeyDown={preventEnterToSubmit}
        />
      );
    case typeForm.datepicker:
      return <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />;
    case typeForm.color:
      return (
        <ColorPicker format={item.formatColor || formatColor.hex} allowClear />
      );
    case typeForm.custom:
      return item.component;
    case typeForm.checkbox:
      return <Checkbox onKeyDown={preventEnterToSubmit} />;
    case typeForm.file:
      return (
        <ImageUploader
          defaultImages={item.defaultImage}
          withIcon={true}
          buttonText={"Uppload"}
          onChange={onDrop}
          imgExtension={[".jpg", ".gif", ".png", ".gif"]}
          maxFileSize={5242880}
          singleImage
          withPreview
        />
      );
    default:
      return <></>;
  }
};

const getColorFromColorFactory = (colorFactory, type = formatColor.hex) => {
  if (!colorFactory) return;

  if (typeof colorFactory === "string") return colorFactory;

  // alpha = 0 in metaColor meaning user clear color
  if (type === formatColor.hex && colorFactory.metaColor.a !== 0) {
    return `#${colorFactory.toHex()}`;
  }

  return null;
};

const handleDownloadFile = (filePath) => {
  // const link = document.createElement('a');
  // link.href = filePath;
  // link.download = true;
  // link.click();

  const link = document.createElement("a");
  link.href = filePath;
  link.download = filePath;
  link.click();
};

const handleUploadFile = (file) => {
  if (file) {
    // Xử lý lưu file vào storage
    console.log(file);
  }
};
function roundToTwo(num) {
  return +(Math.round(num + "e+2") + "e-2");
}

const convertISOToUTC7 = (date, options) => {
  if (!date) return moment().add(7, "hours").toDate();

  const dateM = moment(date).add(7, "hours");

  if (options && options.seconds) {
    dateM.set("second", options.seconds);
  }

  return dateM.toDate();
};

function randomNumber(min = 0, max = 30) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
function dateIsValid(date) {
  return date instanceof Date && !isNaN(date);
}
// Check string is Date format
function isDate(_date) {
  const _regExp = new RegExp(
    "^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$"
  );
  return _regExp.test(_date);
}
//Chuyển đổi số sang định dạng tiền phân cách hàng nghìn
function formatMoney(input) {
  let amount = parseFloat(input);

  if (isNaN(amount) || amount < 0) {
    return "0";
  }
  let result = "";

  while (amount >= 1000) {
    const remainder = amount % 1000;
    amount = Math.floor(amount / 1000);
    result = `.${remainder.toString().padStart(3, "0")}${result}`;
  }

  result = amount.toString() + result;
  return result;
}

function getParentMenuItems(menuConfigs, string) {
  const find = ({ to, content }) =>
    (to ? to.toLowerCase() === string.toLowerCase() : null) ||
    (content && content.some(find));
  return menuConfigs.filter(find);
}

const getMenuIconByUrl = () => {
  const url = window.location.href;
  let icon = "ri-question-line icon-gradient bg-mean-fruit";
  const menuConfigStr = localStorage.getItem("lstFunction");
  const splitted = url.split(/onelis/i);
  if (splitted.length > 1 && menuConfigStr) {
    const currentRoute = `/OneLis${splitted[1]}`;

    const menuConfig = JSON.parse(menuConfigStr) || [];

    try {
      const parentMenuItems = getParentMenuItems(menuConfig, currentRoute);
      if (parentMenuItems && parentMenuItems.length) {
        const icon = parentMenuItems[0].icon;
        return `${IconMapping.getValue(
          icon
        )} icon-gradient bg-mean-fruit font-weight-bold`;
      }
    } catch (err) {
      return icon;
    }
  }

  return icon;
};

const ExcelDateToJSDate = (serial) => {
  let utc_days = Math.floor(serial - 25569);
  let utc_value = utc_days * 86400;
  let date_info = new Date(utc_value * 1000);
  return new Date(
    date_info.getFullYear(),
    date_info.getMonth(),
    date_info.getDate()
  );
};

const ExcelDateToJSDateWithTime = (serial) => {
  let utc_days = Math.floor(serial - 25569);
  let utc_value = utc_days * 86400;
  let date_info = new Date(utc_value * 1000);

  let fractional_day = serial - Math.floor(serial) + 0.0000001;

  let total_seconds = Math.floor(86400 * fractional_day);

  let seconds = total_seconds % 60;

  total_seconds -= seconds;

  let hours = Math.floor(total_seconds / (60 * 60));
  let minutes = Math.floor(total_seconds / 60) % 60;

  return new Date(
    date_info.getFullYear(),
    date_info.getMonth(),
    date_info.getDate(),
    hours,
    minutes,
    seconds
  );
};
const convertSecondToDisplayTime = (totalSeconds) => {
  let hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  let minutes = Math.floor(totalSeconds / 60);
  let seconds = totalSeconds % 60;

  // If you want strings with leading zeroes:
  minutes = String(minutes).padStart(2, "0");
  hours = String(hours).padStart(2, "0");
  seconds = String(seconds).padStart(2, "0");
  return hours + ":" + minutes + ":" + seconds;
};
const naturalSort = (arr = [], key, type = "asc") => {
  if (!arr || !key) return arr;

  if (type === "urgent") {
    arr.sort((a, b) => {
      if (a[key] && !b[key]) {
        return -1;
      } else if (!a[key] && b[key]) {
        return 1;
      } else {
        return 0;
      }
    });
  } else {
    if (type === "asc") {
      arr.sort((a, b) =>
        a[key].localeCompare(b[key], undefined, {
          numeric: true,
          sensitivity: "base",
        })
      );
    } else {
      arr
        .sort((a, b) =>
          a[key].localeCompare(b[key], undefined, {
            numeric: true,
            sensitivity: "base",
          })
        )
        .reverse();
    }
  }
};

const isValidDate = (value) => {
  var dateWrapper = new Date(value);
  return !isNaN(dateWrapper.getDate());
};

const removeSpecialCharacter = (str) => {
  let fString = str;
  if (typeof fString === "number") {
    fString = fString.toString();
  }

  const noSpecialCharacters = (fString || "").replace(/[^a-zA-Z0-9 ]/g, "");
  const noSpace = noSpecialCharacters.replaceAll(" ", "");
  return noSpace;
};

function uniqueObjectInArray(array, property) {
  const uniqueIds = [];

  const unique = array.filter((element) => {
    const isDuplicate = uniqueIds.includes(element[property]);

    if (!isDuplicate) {
      uniqueIds.push(element[property]);

      return true;
    }

    return false;
  });

  return unique;
}

const DateTimeToLocaleDate = (date) => {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    )
  );
};

const useIdDataSource = (source, accessor) => {
  const ids = useMemo(() => {
    if (!source || !source.length) return [];
    const rs = source.reduce((acc, val) => {
      if (!val && val !== 0) return acc;

      let newAcc = [];

      try {
        let newValue = val[accessor];

        if (typeof val[accessor] === "string")
          newValue = val[accessor].toLowerCase();

        newAcc = [...acc, newValue];
      } catch (err) {
        console.log("Error: ", err);
        newAcc = [...acc];
      }
      return newAcc;
    }, []);
    return rs;
  }, [source, accessor]);
  return ids;
};

const hasPermission = (permissionKey) => {
  if (!permissionKey) return false;

  let permission = {};
  const permissionStr = localStorage.getItem("permission");
  if (permissionStr) {
    permission = JSON.parse(permissionStr);
  }

  return Boolean(permission[permissionKey]);
};

const getConfigValueByKey = (configList, key) => {
  if (!key || !configList || !(configList || []).length) return false;

  const idxAccAdd = (configList || []).findIndex((cfg) => cfg.configID === key);

  if (idxAccAdd > -1) {
    return (configList[idxAccAdd].value || "").toLowerCase() === "true";
  }

  return false;
};

function generateString(characterLen = 5, numberLen = 3, specialCharLen = 1) {
  let pass = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const special = "@#$&*";

  // random kí tự đặc biệt
  if (specialCharLen) {
    for (let i = 1; i <= specialCharLen; i++) {
      let char = Math.floor(Math.random() * special.length + 1);

      pass += special.charAt(char);
    }
  }

  // random chữ cái
  if (characterLen) {
    for (let i = 1; i <= characterLen; i++) {
      let char = Math.floor(Math.random() * characters.length + 1);

      pass += characters.charAt(char);
    }
  }

  // random số
  if (numberLen) {
    for (let i = 1; i <= numberLen; i++) {
      let char = Math.floor(Math.random() * numbers.length + 1);

      pass += numbers.charAt(char);
    }
  }

  return pass;
}

const handleErrorMessage = (t, message) => {
  if (!message || typeof message !== "string") return message;
  // Lỗi dữ liệu đã được sử dụng và không thể xóa
  if (
    message.includes(
      "The DELETE statement conflicted with the REFERENCE constraint"
    ) ||
    message.includes(
      "The configuration is already in use and cannot be deleted"
    )
  ) {
    return i18n.t("The configuration is already in use and cannot be deleted", {
      ns: "errors",
    });
  }

  if (message.includes("Không xóa được bệnh nhân đã có kết quả được duyệt")) {
    return i18n.t("not delete use has valid test", { ns: "errors" });
  }
  // Các thông báo lỗi khác có thể handle ở đây
  return t(message);
};
const getShortSID = (fullSID) => {
  if (!fullSID || typeof fullSID !== "string") return "";

  const splitted = fullSID.split("-");

  if (splitted.length < 2) return fullSID;

  return splitted[1];
};

// Detect is object {}
function isObject(input) {
  return (
    null !== input &&
    typeof input === "object" &&
    Object.getPrototypeOf(input).isPrototypeOf(Object)
  );
}

function isNumber(string) {
  return /^[0-9.]*$/.test(string);
}

function isInt(n) {
  return n % 1 === 0;
}

const roundedNumber = (num, options = {}) => {
  if (!num && num !== 0) return null;
  const opts = {
    fracDigitNum: 2, // Lấy bao nhiêu chữ số thập phân
    type: "number", // Kết quả trả về là số hoặc chữ
    ...options,
  };
  const result = num.toFixed(opts.fracDigitNum);

  if (opts.type === "number") return parseFloat(result);

  return result;
};

function seperateNumber(x) {
  if (!x) return 0;
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}

const getBadgeByStatus = (status) => {
  if (!status) return "";
  if (status === "VAL") return "badge badge-success";
  if (status === "CFM") return "badge badge-info";
  if (status === "DEL") return "badge badge-danger";
  if (status === "FUL") return "badge badge-warning";
  if (status === "UPL") return "badge badge-primary";
  return "";
};

// Phân trang offline
// page_number: bắt đầu từ 1
function paginate(array, page_size, page_number) {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
}

// data: blob
// filename: string.extend
function downloadFile(data, filename) {
  const blob = new Blob([data], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

const splitToArrFromString = (str, separate) => {
  if (!separate) return str;

  const split = str.split(separate);
  const rs = split.map((el) => (el || "").trim());
  return rs;
};

export {
  seperateNumber,
  formatDateWithTime,
  rules,
  renderFormComponent,
  getColorFromColorFactory,
  handleDownloadFile,
  downloadFile,
  handleUploadFile,
  formatDate,
  roundToTwo,
  convertISOToUTC7,
  randomNumber,
  dateIsValid,
  formateDateYYYYMMDD,
  isDate,
  formatMoney,
  getMenuIconByUrl,
  getParentMenuItems,
  ExcelDateToJSDate,
  ExcelDateToJSDateWithTime,
  convertSecondToDisplayTime,
  naturalSort,
  removeSpecialCharacter,
  isValidDate,
  uniqueObjectInArray,
  DateTimeToLocaleDate,
  useIdDataSource,
  hasPermission,
  getConfigValueByKey,
  generateString,
  getShortSID,
  isNumber,
  isInt,
  handleErrorMessage,
  roundedNumber,
  getBadgeByStatus,
  paginate,
  formateDateYYYYMMDDWithTime,
  formatTime,
  isObject,
  splitToArrFromString,
};
